async function checkCountry(countryCode) {
  try {
    const response = await fetch(`https://restcountries.com/v3.1/alpha/${countryCode}`);
    if (!response.ok) throw new Error(`API error: ${response.status}`);
    const data = await response.json();
    const countryData = data[0];
    const lang = Object.values(countryData.languages).join(', ');
    return lang;
  } catch (error) {
    console.error('Failed to fetch country info:', error);
    return null;
  }
}

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.elements.button.focus();
  }

  async onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    const selectedValue = event.currentTarget.dataset.value;
    this.elements.input.value = selectedValue;
    const langString = await checkCountry(selectedValue);
    if (!langString) return;
    const googleSelect = document.querySelector('#google_translate_element select.goog-te-combo');
    if (!googleSelect) return;
    const langs = langString.toLowerCase().split(',').map(l => l.trim());
    let matched = false;
    for (const option of googleSelect.options) {
      const optionText = option.text.toLowerCase();
      if (langs.some(lang => optionText.includes(lang))) {
        googleSelect.value = option.value;
        googleSelect.dispatchEvent(new Event('change', { bubbles: true }));
        matched = true;
        setTimeout(function(){
          if (form) form.submit();
          localStorage.setItem("country", true);
        },2000);
        break;
      }
    }
    
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
